import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Navbar from './navbar'

const Header = ({ pageInfo, location }) => (
  <header className="header">
    <Container className="col-11">
      <Row>
        <Col>
          <Navbar pageInfo={pageInfo} location={location} />
        </Col>
      </Row>
    </Container>
  </header>
)

export default Header
